import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind class lists, dedupe conflicts, drop falsy.
 * Standard pattern across the design system.
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
